import { gql } from '@apollo/client';

export default gql`
  query exchangeSearch(
    $exchangeItems: [Int]
    $reference: String!
    $origin: String!
    $destination: String!
    $returningOrigin: String
    $returningDestination: String
    $outboundDate: String
    $inboundDate: String
    $currency: String
    $isSwapStations: Boolean
    $isBPNonFlexOutboundExchange: Boolean
    $isBPNonFlexInboundExchange: Boolean
    $summatedFares: InputSummatedFares
    $multipleFlexibility: Boolean
    $applySummatedFaresMaxTransferRules: Boolean
    $offerSummatedFares: Boolean
    $maxTransfers: Int
    $useNewLoyaltySystem: Boolean
  ) {
    exchangeSearch(
      exchangeItems: $exchangeItems
      reference: $reference
      outboundDate: $outboundDate
      inboundDate: $inboundDate
      origin: $origin
      destination: $destination
      returningOrigin: $returningOrigin
      returningDestination: $returningDestination
      currency: $currency
      isSwapStations: $isSwapStations
      isBPNonFlexOutboundExchange: $isBPNonFlexOutboundExchange
      isBPNonFlexInboundExchange: $isBPNonFlexInboundExchange
      summatedFares: $summatedFares
      multipleFlexibility: $multipleFlexibility
      applySummatedFaresMaxTransferRules: $applySummatedFaresMaxTransferRules
      offerSummatedFares: $offerSummatedFares
      maxTransfers: $maxTransfers
      useNewLoyaltySystem: $useNewLoyaltySystem
    ) {
      outbound {
        ...exchangeOffer
      }
      inbound {
        ...exchangeOffer
      }
      passengers {
        id
        type
        birthDate
        disabilityType
      }
      productFamiliesWithFares @client
    }
  }
  fragment exchangeOffer on Offer {
    totalPriceOfOriginalExchangeItems
    isWheelchair
    origin {
      uic
      name
    }
    destination {
      uic
      name
    }
    productFamilies {
      name
      code
      familyGroup
      familyGroupName
    }
    classesOfService {
      code
      name
    }
    journeys {
      timing {
        departs
        arrives
        duration
      }
      fares {
        buckets {
          code
          price
          passengerType
          availability
          physicalAvailability
          highestBucketCodeLogicalAvailability
        }
        legs {
          serviceName
          trainNumber
          serviceIdentifier
          serviceType {
            name
            code
            brandCode
          }
          origin {
            name
            uic
          }
          destination {
            name
            uic
          }
          timing {
            departureDate
            arrivalDate
            departs
            arrives
            duration
          }
          products {
            name
            isFareAddOn
            passengerId
            tariffCode
            bucketCode
            code
            loyaltyPoints
            price
            originalPrice
          }
          classOfService {
            code
            name
          }
        }
        offlineFee @client
        isLyria @client
        isSummatedFare
        isThroughFare
        fees {
          tariffCode
          price
          name
          passengerId
          code
        }
        productFamily {
          code
          name
          familyGroup
          familyGroupName
        }
        classOfService {
          code
          name
        }
        canBeBooked
        canLoyaltyFareBeExchangedToBP
        prices {
          displayPrice
        }
        promo {
          type
          value
        }
        bookingItems {
          passengerId
          tariffCode
          price
          loyaltyPoints
        }
      }
    }
  }
`;
